module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-arrow-up-left-4f132374.svg";